import store from "@/store";

var NotificationCollapseHandler = (function () {

    const SEVEN_SCONDS = 7000;

    var _timeout = null;

    function handleTimeout(isOpen = false) {
        clearTimeout(_timeout);

        if (isOpen) {
            _timeout = setTimeout(hideErrorNotification, SEVEN_SCONDS);
        }
    }

    function hideErrorNotification() {
        return store.dispatch('errorNotificationStore/hideErrorNotification');
    }

    return {
        handleTimeout: handleTimeout,
    }

})();

export default NotificationCollapseHandler;
